import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const pinIcon = (count) =>
  L.divIcon({
    className: "",
    html: `<div style="background:#15803d;color:#fff;border-radius:9999px;min-width:28px;height:28px;padding:0 4px;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:12px;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4)">${count}</div>`,
    iconSize: [28, 28],
    iconAnchor: [14, 14],
  });

export default function JobsMap() {
  const [pins, setPins] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/cities/map`).then((r) => setPins(r.data.pins || [])).catch(() => setPins([]));
  }, []);

  const bounds = useMemo(() => {
    if (!pins || pins.length === 0) return null;
    return L.latLngBounds(pins.map((p) => [p.lat, p.lng])).pad(0.5);
  }, [pins]);

  if (!pins) {
    return <p className="text-sm text-green-800" data-testid="jobs-map-loading">Carregando mapa de vagas...</p>;
  }
  if (pins.length === 0) return null;

  return (
    <div data-testid="jobs-map">
      <p className="text-sm font-semibold text-gray-900 mb-2">
        🗺️ Mapa de vagas — toque no pontinho para ver as vagas da cidade
      </p>
      <div className="rounded-xl overflow-hidden border shadow-sm" style={{ position: "relative", zIndex: 0 }}>
        <MapContainer bounds={bounds} boundsOptions={{ maxZoom: 8 }} style={{ height: 340, width: "100%" }} scrollWheelZoom={false}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {pins.map((p) => (
            <Marker key={p.slug} position={[p.lat, p.lng]} icon={pinIcon(p.jobs.length)}>
              <Popup>
                <div style={{ minWidth: 180 }}>
                  <p style={{ fontWeight: 700, margin: 0 }}>📍 {p.city}{p.uf ? `-${p.uf}` : ""}</p>
                  {p.jobs.slice(0, 5).map((j) => (
                    <Link key={j.id} to={`/vaga/${j.id}`} style={{ display: "block", marginTop: 6, fontSize: 12, color: "#15803d", textDecoration: "underline" }}>
                      {j.title} →
                    </Link>
                  ))}
                  <Link to={`/vagas/${p.slug}`} style={{ display: "block", marginTop: 8, fontSize: 12, fontWeight: 700, color: "#14532d", textDecoration: "underline" }}>
                    Todas as vagas de {p.city} →
                  </Link>
                </div>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
    </div>
  );
}
